import React, { useState } from 'react';
import CardBackSide from '../../../../assets/ampol-card/card-back-side.png';
import CardFrontSide from '../../../../assets/ampol-card/card-back-side.png';
import AmpolCardFallback from 'assets/AmpolCardFallback.png';

import './add-edit-card-image.scss';

/**
 * Describe component here
 * @param props
 */
const AddEditCardImage = ({
  plasticType,
  embossingLine2,
  embossingName,
  regoNumber,
  expiryDate,
}) => {
  const [plasticImageURL, setPlasticImageURL] = useState(
    plasticType?.image?.url
  );
  return (
    <div className={'add-edit-card-image'}>
      <div className={'edit-card-image'}>
        <img
          src={`${plasticImageURL ?? CardFrontSide}`}
          alt="card-image"
          width="100%"
          height="auto"
          onError={() => {
            setPlasticImageURL(AmpolCardFallback);
          }}
        />
        <div className={'add-edit-card-image__info'}>
          <div>{embossingName}</div>
          <div className={'add-edit-card-image__emobossing-line2'}>
            {embossingLine2}
          </div>
          <div className={'add-edit-card-image__rego-expirydate'}>
            <div>{regoNumber}</div>
            <div>{expiryDate}</div>
          </div>
        </div>
      </div>
      <div className={'edit-card-image'}>
        <img src={CardBackSide} alt="card-image" width="100%" height="auto" />
      </div>
    </div>
  );
};

export default AddEditCardImage;
